import { useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  layersTwo,
  messageIcon,
  sideNavSettingsIcon,
} from "../../../utility-functions/assetLoader";
import countries from "../countries/Countries.json";
import classes from "./WhatsappSideNav.module.css";
import { images } from "../../call-pricing/flagsImported";
import libphonenumber from "google-libphonenumber";

const WhatsappSideNav = () => {
  const {
    canManageBillingSubscription,
    canSendWhatsappMessage,
    canManageWhatsappMessageTemplates,
  } = useSelector((state) => state?.auth?.permissions);

  const creds = useSelector((state) => state?.whatsappBusiness?.value);

  const flagName = useMemo(() => {
    const isoCode = getCountryISO2FromPhone(creds?.phone_numbers?.[0]?.country_code + creds?.phone_numbers?.[0]?.phone_number)
    if (isoCode) {
      return countries?.find(
        (c) => c?.iso2 === isoCode?.toLowerCase())?.name
    } else {
      return countries?.find(
        (c) => c?.dialCode === creds?.phone_numbers?.[0]?.country_code?.slice(1)
      )?.name
    }
  }, [countries, creds]);

  //Handlers
  function handleScrollForNav() {
    const _scrolledBy = Math.ceil(
      Math.abs(document.body.getBoundingClientRect().top)
    );

    const getBannerHeight = () =>
      parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue("--pf-banner-height")
          .trim()
      ) || 0;

    const bannerHeight = getBannerHeight();
    const TOP_OFFSET = 64 + bannerHeight;

    const _sideNav = document.getElementById("side-nav");

    if (_scrolledBy === 0) {
      _sideNav.style.position = "fixed";
      _sideNav.style.top = `${64 + bannerHeight}px`;
      _sideNav.style.left = "unset";
      _sideNav.style.height = "calc(100vh - 64px)";
      _sideNav.classList.remove("with-top-border");
      return;
    }
    if (_scrolledBy < TOP_OFFSET) {
      let negativeScrollAdjustment = -window.scrollY;
      _sideNav.style.position = "fixed";
      _sideNav.style.top = `calc(64px + ${bannerHeight}px + ${negativeScrollAdjustment}px)`;
      _sideNav.style.left = "unset";
      _sideNav.style.height = `calc(100vh - 64px - ${negativeScrollAdjustment}px)`;
      _sideNav.classList.add("with-top-border");
      return;
    }

    _sideNav.style.position = "fixed";
    _sideNav.style.top = "0px";
    _sideNav.style.left = "0";
    _sideNav.style.height = "100vh";
    _sideNav.classList.add("with-top-border");
  }

  //Effects
  useEffect(() => {
    window.addEventListener("scroll", handleScrollForNav);
    return () => window.removeEventListener("scroll", handleScrollForNav);
  }, []);

  return (
    <div className={classes.sidebarContainer} id="side-nav">
      <div className={`${classes.menuItem} ${classes.vn}`}>
        {images[flagName] ? <img src={images[flagName]} alt="flag" /> : ""}
        <span
          style={{
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {creds?.phone_numbers?.[0]?.name}
        </span>
        <div className={classes.vnDetail}>
          <img src={images[flagName]} alt="flag" />
          <div>
            <span>{creds?.phone_numbers?.[0]?.name}</span>
            <span className={classes.number}>
              {creds?.phone_numbers?.[0]?.country_code +
                " " +
                creds?.phone_numbers?.[0]?.phone_number}
            </span>
          </div>
        </div>
      </div>

      {canSendWhatsappMessage && (
        <div className="w-chat-pf">
          <NavLink
            to="/w-chat"
            className={({ isActive }) =>
              isActive
                ? `${classes.menuItem} ${classes.active}`
                : classes.menuItem
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <span>{messageIcon("#219848", "20px", "20px")}</span>
                ) : (
                  <span>{messageIcon("#3F3F46", "20px", "20px")}</span>
                )}
                <span>Chats</span>
              </>
            )}
          </NavLink>
        </div>
      )}
      {canManageWhatsappMessageTemplates && (
        <div className="w-template-pf">
          <NavLink
            to="/w-template"
            className={({ isActive }) =>
              isActive
                ? `${classes.menuItem} ${classes.active}`
                : classes.menuItem
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <span>{layersTwo("#219848")}</span>
                ) : (
                  <span>{layersTwo()}</span>
                )}
                <span>Templates</span>
              </>
            )}
          </NavLink>
        </div>
      )}

      {canManageBillingSubscription && (
        <div className="w-settings-pf">
          <NavLink
            target="_blank"
            rel="noopener noreferrer"
            to="https://business.facebook.com/latest/whatsapp_manager/phone_numbers"
            className={({ isActive }) =>
              isActive
                ? `${classes.menuItem} ${classes.active}`
                : classes.menuItem
            }
          >
            {({ isActive }) => (
              <>
                {isActive ? (
                  <span>{sideNavSettingsIcon("#219848")}</span>
                ) : (
                  <span>{sideNavSettingsIcon("#3F3F46")}</span>
                )}
                <span>Settings</span>
              </>
            )}
          </NavLink>
        </div>
      )}
    </div>
  );
};

export default WhatsappSideNav;

function getCountryISO2FromPhone(phoneNumber) {
  const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
  try {
    const number = phoneUtil.parse(phoneNumber);
    const regionCode = phoneUtil.getRegionCodeForNumber(number);
    return regionCode || null;
  } catch (error) {
    console.error('Error parsing phone number:', error.message);
    return null;
  }
}